import React from 'react';
import { useTranslation } from 'react-i18next';

const ICONS = [
  // Rulers / dimensions
  <svg key="dim" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path d="M3 17l14-14M6 14l-3 3 3-3M14 6l3-3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3 14v3h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 6V3h-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  // Roof / house
  <svg key="roof" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path d="M3 10l7-7 7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 10v7h10v-7" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>,
  // Grid / panels
  <svg key="panels" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <rect x="3" y="3" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <rect x="11" y="3" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <rect x="3" y="11" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <rect x="11" y="11" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" />
  </svg>,
  // Price tag
  <svg key="price" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path d="M10 3H3v7l7 7 7-7-7-7z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <circle cx="6.5" cy="6.5" r="1" fill="currentColor" />
  </svg>,
  // List / spec
  <svg key="spec" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path d="M7 5h10M7 10h10M7 15h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="3.5" cy="5" r="1" fill="currentColor" />
    <circle cx="3.5" cy="10" r="1" fill="currentColor" />
    <circle cx="3.5" cy="15" r="1" fill="currentColor" />
  </svg>,
  // Embed / code
  <svg key="embed" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path d="M7 6l-4 4 4 4M13 6l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  // Chart / analytics
  <svg key="stats" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path d="M3 17V9M8.5 17V4M14 17v-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3 17h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>,
  // Save / bookmark
  <svg key="saved" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path d="M5 3h10a1 1 0 011 1v13l-6-3-6 3V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>,
];

const FeatureCard = ({ icon, title, description }) => (
    <div className="group flex flex-col gap-4 p-5 rounded-2xl bg-gray-800/40 border border-gray-700/50
                  hover:bg-gray-800/70 hover:border-gray-600/60 transition-all duration-200">
      <div className="w-10 h-10 rounded-xl bg-gray-700/60 border border-gray-600/40
                    flex items-center justify-center text-emerald-400
                    group-hover:bg-emerald-600/15 group-hover:border-emerald-600/30
                    transition-all duration-200">
        {icon}
      </div>
      <div className="flex flex-col gap-1.5">
        <h3 className="text-white font-semibold text-sm">{title}</h3>
        <p className="text-gray-400 text-sm leading-relaxed">{description}</p>
      </div>
    </div>
);

const FeaturesSection = () => {
  const { t } = useTranslation();
  const items = t('features.items', { returnObjects: true });

  return (
      <section id="features" className="py-24 bg-gray-950 border-t border-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="text-center mb-14">
          <span className="inline-block text-emerald-500 text-xs font-bold tracking-widest uppercase mb-3">
            {t('features.label')}
          </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              {t('features.title')}
            </h2>
            <p className="text-gray-400 text-lg max-w-xl mx-auto">
              {t('features.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {items.map((item, i) => (
                <FeatureCard
                    key={i}
                    icon={ICONS[i]}
                    title={item.title}
                    description={item.description}
                />
            ))}
          </div>
        </div>
      </section>
  );
};

export default FeaturesSection;
